import { render, staticRenderFns } from "./ClientIncomingRegionReportView.vue?vue&type=template&id=196e29de&scoped=true"
import script from "./ClientIncomingRegionReportView.vue?vue&type=script&lang=js"
export * from "./ClientIncomingRegionReportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196e29de",
  null
  
)

export default component.exports